import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_SGffMBrdSrNh: {
	id: 'prd_SGffM2DEV2BrdSrNh'
	ident: 'prd_SGffMBrdSrNh'
	sku: 'simple_premium_12w_13_59_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_alUGv2DEV26sdFJzr'
			amount: 79
			amount_usd: 13.59
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 13.59
			discount: 65.41
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_0CxbN2DEV2tCpzZlu'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_SGffMBrdSrNh, SubscriptionProduct>
const prd_SGffMBrdSrNh = { ident: 'prd_SGffMBrdSrNh' } as typeof _prd_SGffMBrdSrNh

export default prd_SGffMBrdSrNh
